export default "__VITE_ASSET__Bp_aFBlW__"